// src/services/marketplaceService.js
import api from './api';

export const marketplaceService = {
  // Installer Profile
  getInstallerProfile: (id) => api.get(`/marketplace/installers/${id}/`),
  getAllInstallers: (params) => api.get('/marketplace/installers/', { params }),
  
  // Bids
  getBids: () => api.get('/marketplace/bids/'),
  createBid: (data) => api.post('/marketplace/bids/', data),
  acceptBid: (id) => api.post(`/marketplace/bids/${id}/accept/`),
  rejectBid: (id) => api.post(`/marketplace/bids/${id}/reject/`),
  
  // Contracts
  getContracts: () => api.get('/marketplace/contracts/'),
  getContract: (id) => api.get(`/marketplace/contracts/${id}/`),
  signContract: (id) => api.post(`/marketplace/contracts/${id}/sign/`),
  
  // Availability
  getAvailability: (installerId) => 
    api.get('/marketplace/availability/', { params: { installer: installerId } }),
  setAvailability: (data) => api.post('/marketplace/availability/', data),
};